export enum IssuanceProductionStatus {
  PENDING = "pending",
  SUBMITTED = "submitted",
  ACCEPTED = "accepted",
  REJECTED = "rejected",
  COMPLETED = "completed",
}

export enum IssuanceDataSource {
  LT_ESO = "lt_eso",
  ES_FILE = "es_file",
  PL_EMAIL = "pl_email",
  PL_FILE = "pl_file",
  MANUAL = "manual",
}

export function getIssuanceStatusBadgeClass(
  status: IssuanceProductionStatus | string
): string {
  const classes: Record<string, string> = {
    [IssuanceProductionStatus.PENDING]: "bg-warning",
    [IssuanceProductionStatus.SUBMITTED]: "bg-info",
    [IssuanceProductionStatus.ACCEPTED]: "bg-success",
    [IssuanceProductionStatus.COMPLETED]: "bg-primary",
    [IssuanceProductionStatus.REJECTED]: "bg-danger",
  };
  return classes[status] ?? "bg-secondary";
}
